import { registerNodeType } from '../../registry'
import { ICONIFY } from '../../../../../Constants/iconify'
import CalendarNode from './CalendarNode'
import CalendarConfig from './CalendarConfig'

registerNodeType({
  type: 'CALENDAR',
  label: 'Calendar',
  icon: ICONIFY.CALENDAR,
  color: '#EF6C00',
  hasOptions: false,
  excludeFields: ['inputMode', 'inputRegex', 'minSize', 'maxSize'],
  defaults: {},
  nodeComponent: CalendarNode,
  configComponent: CalendarConfig,
})
